import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

const contentWrapper = css`
  height: 185px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;

  > :first-child {
    margin-bottom: 20px;
  }

  > span {
    color: ${colors.black};
  }
`;

const radioGroup = css`
  > label {
    margin-bottom: 10px;

    > span {
      font-weight: ${fonts.weight.regular};
      color: ${colors.black};
    }
  }
`;

const buttonSection = css`
  margin: 20px 20px 0;
  display: flex;
  justify-content: end;
`;

export default { contentWrapper, radioGroup, buttonSection };
